import { I18nextProvider } from 'react-i18next'

import { ClientContextController } from '@percent/hosted-donation-gateway/context/client/clientContextController/ClientContextController'
import { ThemeContext } from '@percent/hosted-donation-gateway/context/theme/ThemeProvider/ThemeProvider'
import { PartnerConfigContextController } from '@percent/hosted-donation-gateway/context/partnerConfig/PartnerConfigContextController/PartnerConfigContextController'
import { LoggerContextController } from '@percent/hosted-donation-gateway/context/logger/LoggerContextController/LoggerContextController'
import { CurrencyContextController } from '@percent/hosted-donation-gateway/context/currency/currencyContextController/currencyContextController'
import { TokenContextController } from '@percent/hosted-donation-gateway/context/token/TokenContextController/TokenContextController'
import { SessionContextController } from '@percent/hosted-donation-gateway/context/session/SessionContextController/SessionContextController'
import { UserLocationContextController } from '@percent/hosted-donation-gateway/context/userLocation/userLocationContextController/userLocationContextController'
import { AppProvidersProps } from './AppProviders.types'
import i18n from '@percent/hosted-donation-gateway/i18n/config'

export function AppProviders({ children }: AppProvidersProps) {
  return (
    <LoggerContextController>
      <I18nextProvider i18n={i18n}>
        <PartnerConfigContextController>
          <SessionContextController>
            <UserLocationContextController>
              <CurrencyContextController>
                <ThemeContext>
                  <TokenContextController>
                    <ClientContextController>{children}</ClientContextController>
                  </TokenContextController>
                </ThemeContext>
              </CurrencyContextController>
            </UserLocationContextController>
          </SessionContextController>
        </PartnerConfigContextController>
      </I18nextProvider>
    </LoggerContextController>
  )
}
